module.exports = __webpack_public_path__ + "static/img/icon.211fbde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon.svg
// module id = Z9fo
// module chunks = 1